<template>
  <!-- <div>In Good4Work, everybody can value the work of others.</div> -->
  <b-carousel
    :interval="0"
    controls
    indicators
    class="kudos-instructions"
  >
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/kudo-empty.png" fluid></b-img>
      <p class="mt-5">In Good4Work, everybody can value the work of others.</p>
      <p>Your peers, your internal customers or managers, everyone in the company can give you a kudo for your skills or soft skills.</p>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/tutorial2.png" fluid></b-img>
      <p class="mt-5">People can choose to give you kudos either publicly or anonymously.</p>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/slide-kudos.png" fluid></b-img>
      <p class="mt-5">You can give various kudos, each one rewarding a specific skill of the receiver.</p>
      <p>We distinguish two types of skills, the positive behavior (soft skill) and the expertise (technical skill).</p>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/slide4.png" fluid></b-img>
      <p class="mt-5">External customers can endorse you as well for your skills and positive behaviors.</p>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/tutorial5.png" fluid></b-img>
      <p class="mt-5">You can see the level of proficiency of a skill with the border of the kudo icon.</p>
      <p>Depending on the number of the kudos received, you will see at a glance who is the best person in this domain.</p>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <p>To give a kudo to a person:</p>
      <p>Select the person through the quick menu</p>
      <b-img src="@/assets/images/instructions/tutorial7.png" fluid></b-img>
      <p class="m-4">Or select the members in the team profile</p>
      <b-img src="@/assets/images/instructions/tutorial6.png" fluid></b-img>
    </b-carousel-slide>
    <b-carousel-slide img-blank>
      <b-img src="@/assets/images/instructions/tutorial8.png" fluid></b-img>
      <p class="mt-5">Don't forget to take a look at the kudos library to explore the different ways to value people around you.</p>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  name: 'KudoInstructions'
}
</script>
